import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireinbaramati() {



const cardData =
  {
    keyword: 'Bus Hire in Baramati',
    heading: 'Sanavi Travels: Bus Hire in Baramati',
    headingDescription: 'Sanavi Travels offers professional, reliable, and fully managed Bus Hire in Baramati, catering to families, corporate organizations, educational institutions, wedding parties, picnic groups, industrial staff, and outstation travelers. Baramati is one of the most prominent cities in Pune district, known for its educational hubs, industrial zones, agricultural economy, political importance, and excellent road connectivity. Due to frequent movement for corporate events, school trips, social functions, religious travel, and long-distance journeys, organized group transportation is a daily requirement in Baramati. To meet these diverse travel needs, we provide a wide fleet of AC buses, Non-AC buses, luxury coaches, mini buses, and high-capacity buses suitable for short local travel as well as extended outstation journeys. Every bus is well maintained with clean interiors, comfortable cushioned seating, smooth suspension, proper ventilation, and ample luggage space, ensuring a relaxed and safe travel experience for passengers of all age groups. Our experienced drivers are well familiar with Baramati city roads, MIDC areas, rural surroundings, Pune city routes, Pune–Solapur Highway, and nearby districts, ensuring punctual pickups, disciplined driving, and smooth navigation even during peak hours. With flexible rental packages, transparent pricing, and 24/7 customer support, Sanavi Travels makes bus hire in Baramati efficient, affordable, and completely stress-free for every occasion.',

    top: 'Top Places to Visit in Baramati with Sanavi Travels',


"topPlaces": [
  {
    "title": "Baramati City Area",
    "description": "Baramati city is a well-developed urban center with educational institutions, commercial markets, hospitals, and residential zones. Group travel within the city is common for corporate meetings, school events, social gatherings, and family functions. Bus hire services help manage organized transportation across busy city roads while ensuring safety, comfort, and punctuality."
  },
  {
    "title": "Baramati MIDC and Industrial Zone",
    "description": "The Baramati MIDC area houses major manufacturing units and industrial facilities, attracting daily employee movement, corporate visitors, and official delegations. Bus hire services are widely used for employee transportation, factory shifts, corporate travel, and industrial visits, offering safe, reliable, and scheduled group movement."
  },
  {
    "title": "Agricultural and Rural Surroundings",
    "description": "Baramati is surrounded by fertile agricultural villages known for sugarcane, farming activities, and cooperative societies. Group travel is frequent for agricultural meetings, market visits, village events, and rural development programs. Bus rentals provide convenient and economical transportation across rural routes."
  },
  {
    "title": "Educational Institutions and Campuses",
    "description": "Baramati is an educational hub with schools, colleges, and professional institutes attracting students from surrounding regions. Educational tours, sports events, cultural programs, and inter-college travel often require organized bus transportation for students and staff."
  },
  {
    "title": "Religious and Spiritual Centers",
    "description": "Temples and spiritual sites in and around Baramati attract devotees throughout the year. Bus hire services are ideal for group temple visits, religious programs, and festival travel, ensuring peaceful and coordinated journeys."
  },
  {
    "title": "Pune–Solapur Highway Connectivity",
    "description": "Baramati enjoys excellent connectivity via the Pune–Solapur Highway, making it an important transit point for long-distance travel. Bus rentals offer safe highway travel, reduced fatigue, and cost-effective group transportation."
  },
  {
    "title": "Corporate and Political Events",
    "description": "Baramati frequently hosts large-scale corporate events, conferences, political meetings, and public programs. Bus hire services help manage guest transportation efficiently during such events, reducing traffic and coordination challenges."
  },
  {
    "title": "Picnic and Leisure Spots",
    "description": "Families, schools, and organizations often plan picnics and leisure trips from Baramati to nearby destinations. Hiring a bus ensures safe, enjoyable, and well-coordinated travel for all participants."
  },
  {
    "title": "Wedding and Social Event Venues",
    "description": "Wedding lawns, banquet halls, and event venues in Baramati generate high demand for guest transportation. Bus rentals simplify wedding logistics by ensuring guests arrive together and on time."
  },
  {
    "title": "Outstation Travel Destinations",
    "description": "Baramati serves as a starting point for travel to Pune, Solapur, Ahmednagar, Satara, and pilgrimage destinations. Outstation bus rentals provide comfortable and economical solutions for long-distance group travel."
  }
]
,



"services": [
{
"name": "Bus Hire in Baramati",
"description": "Bus Hire in Baramati provides safe, comfortable, and professionally managed transportation for families, corporates, schools, and social groups. This service is ideal for weddings, corporate events, educational trips, picnics, industrial travel, and outstation journeys. Our buses feature clean interiors, cushioned seating, smooth suspension, proper ventilation, and ample luggage space, ensuring a relaxed travel experience. Experienced drivers ensure disciplined driving, punctual pickups, and smooth navigation across city, rural, and highway routes, making group travel organized and stress-free."
},
{
"name": "Bus on Rent Baramati",
"description": "Bus on Rent Baramati offers flexible rental options for local travel, full-day bookings, and long-distance trips. With reliable vehicles and professional drivers, group transportation becomes efficient and well coordinated."
},
{
"name": "AC Bus Rental Baramati",
"description": "AC Bus Rental Baramati is ideal for summer travel and long journeys, providing air-conditioned comfort, relaxed seating, and reduced travel fatigue for passengers."
},
{
"name": "Non AC Bus Hire Baramati",
"description": "Non AC Bus Hire Baramati offers economical transportation for short routes, rural travel, school trips, and local group movement without compromising safety."
},
{
"name": "Luxury Bus Hire Baramati",
"description": "Luxury Bus Hire Baramati delivers a premium travel experience with modern interiors, superior seating, enhanced comfort, and professional service for weddings, VIP guests, and corporate travel."
},
{
"name": "Mini Bus Hire Baramati",
"description": "Mini Bus Hire Baramati is suitable for small to medium-sized groups such as families, office teams, and student batches, offering flexibility and cost efficiency."
},
{
"name": "32 Seater Bus Hire Baramati",
"description": "32 Seater Bus Hire Baramati is ideal for school excursions, corporate outings, and medium-sized group travel, balancing capacity with comfort."
},
{
"name": "35 Seater Bus Rental Baramati",
"description": "35 Seater Bus Rental Baramati supports large group transportation needs such as weddings, conferences, religious tours, and long-distance travel."
},
{
"name": "Bus Hire Baramati for Wedding",
"description": "Bus Hire Baramati for Wedding ensures coordinated and timely transportation for wedding guests, simplifying event logistics and reducing travel stress."
},
{
"name": "Bus Hire Baramati for Corporate Travel",
"description": "Bus Hire Baramati for Corporate Travel offers professional transport solutions for employee movement, meetings, conferences, and corporate outings."
},
{
"name": "Bus Hire Baramati for Picnic",
"description": "Bus Hire Baramati for Picnic provides safe and enjoyable group travel for schools, colleges, families, and organizations planning leisure outings."
},
{
"name": "Bus Rental Baramati Outstation",
"description": "Bus Rental Baramati Outstation offers dependable long-distance transportation to nearby cities and pilgrimage destinations with comfort and safety."
},
{
"name": "Bus Hire Baramati with Driver",
"description": "Bus Hire Baramati with Driver provides chauffeur-driven buses where experienced drivers handle routes, traffic, and scheduling."
},
{
"name": "Cheap Bus Hire Baramati",
"description": "Cheap Bus Hire Baramati delivers budget-friendly transportation without compromising cleanliness, comfort, or reliability."
},
{
"name": "Best Bus Service Baramati",
"description": "Best Bus Service Baramati is trusted for punctual service, clean buses, transparent pricing, and customer satisfaction delivered by Sanavi Travels."
}
],
"tableData": [
["Bus Hire in Baramati", "Bus on Rent Baramati"],
["AC Bus Rental Baramati", "Non AC Bus Hire Baramati"],
["Luxury Bus Baramati", "Mini Bus Hire Baramati"],
["32 Seater Bus Baramati", "35 Seater Bus Baramati"],
["Wedding Bus Baramati", "Corporate Bus Baramati"],
["Picnic Bus Baramati", "Outstation Bus Baramati"],
["Bus Hire Baramati with Driver", "Cheap Bus Hire Baramati"],
["Best Bus Service Baramati", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus Hire in Baramati with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and professional bus hire services in Baramati for all travel needs."
  },
  {
    "WhyChooseheading": "Wide Range of Buses",
    "WhyChoosedescription": "AC, Non AC, luxury, mini, and large seating capacity buses available."
  },
  {
    "WhyChooseheading": "Experienced Local Drivers",
    "WhyChoosedescription": "Drivers are familiar with Baramati city, MIDC, rural routes, and highways."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Clear pricing with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Round-the-clock assistance for bookings and travel support."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Hourly, full-day, and outstation rental options available."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Buses are sanitized before every journey."
  },
  {
    "WhyChooseheading": "On-Time and Reliable Service",
    "WhyChoosedescription": "Guaranteed punctual pickups and smooth operations."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus hire services in Baramati?',
    answer: 'Yes, Sanavi Travels offers reliable bus hire services in Baramati.'
  },
  {
    question: 'What types of buses are available in Baramati?',
    answer: 'AC buses, Non AC buses, mini buses, luxury buses, 32-seater and 35-seater buses are available.'
  },
  {
    question: 'Is bus hire available for corporate and industrial travel?',
    answer: 'Yes, we provide dedicated buses for corporate and industrial transportation.'
  },
  {
    question: 'Can I book a bus for outstation travel from Baramati?',
    answer: 'Yes, outstation bus rentals are available from Baramati.'
  },
  {
    question: 'Are the buses sanitized?',
    answer: 'Yes, all buses are sanitized before every journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Deshpande',
    feedback: 'We hired a bus in Baramati for a corporate event. Very professional and punctual service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Pooja Kulkarni',
    feedback: 'Excellent bus service for our family wedding in Baramati. Clean bus and polite driver.',
    rating: 5
  }
];


















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];






const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire in Baramati - Sanavi Travels",
  "description": "Sanavi Travels provides bus hire in Baramati for weddings, corporate travel, picnics, and outstation trips. We offer AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};









  return (
    <div>
<Helmet>
  <title>
    Call : +91 7387507373 | Bus Hire in Baramati | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus hire in Baramati with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/230.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireinbaramati;